// extracted by mini-css-extract-plugin
module.exports = {"ant-form-item":"tax_ant-form-item_18mi8"};